import React, { Component } from 'react';
import { apiInterfaceForJson } from '../../../services/common/apiManager';

class KipuPendingOrders extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orders: [],
            total: 0,
            loading: false,
            reprocessing: {}
        };
    }

    componentDidMount() {
        this.loadOrders();
    }

    loadOrders = () => {
        this.setState({ loading: true });
        apiInterfaceForJson('/kipuPendingOrders', 'GET').then(res => {
            if (res && res.data) {
                this.setState({ orders: res.data, total: res.total, loading: false });
            }
        }).catch(() => this.setState({ loading: false }));
    }

    reprocess = (order) => {
        this.setState({ reprocessing: { ...this.state.reprocessing, [order._id]: true } });
        apiInterfaceForJson('/kipuPendingOrders/reprocess', 'POST', { orderId: order._id })
            .then(res => {
                if (res && res.status === 200) {
                    alert(`Order ${order.lab_order_id} has been reset. Please ask KIPU to resend the HL7 message.`);
                    this.loadOrders();
                }
            })
            .catch(() => {
                this.setState({ reprocessing: { ...this.state.reprocessing, [order._id]: false } });
            });
    }

    formatDate = (date) => {
        if (!date) return '-';
        return new Date(date).toLocaleDateString();
    }

    hoursAgo = (date) => {
        if (!date) return '-';
        const hours = Math.floor((new Date() - new Date(date)) / 1000 / 3600);
        if (hours < 48) return `${hours}h ago`;
        const days = Math.floor(hours / 24);
        return `${days}d ago`;
    }

    render() {
        const { orders, loading, total, reprocessing } = this.state;

        return (
            <div className="container-fluid">
                <div className="row mb-3">
                    <div className="col-12 d-flex justify-content-between align-items-center">
                        <h4 className="page-title mb-0">
                            <i className="fas fa-exclamation-triangle text-warning mr-2"></i>
                            KIPU Pending Orders
                        </h4>
                        <button className="btn btn-primary btn-sm" onClick={this.loadOrders}>
                            <i className="fas fa-sync mr-1"></i> Refresh
                        </button>
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-md-3">
                        <div className="card text-center">
                            <div className="card-body py-2">
                                <h3 className={`mb-0 ${total > 0 ? 'text-danger' : 'text-success'}`}>{total}</h3>
                                <small>Orders Pending 48+ Hours</small>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="card-header">
                        <h6 className="mb-0">KIPU Orders with No Sample Received (48+ Hours)</h6>
                        <small className="text-muted">These orders were received from KIPU but no sample has been accessioned. Click "Reset & Resend" to reset the order and ask KIPU to resend.</small>
                    </div>
                    <div className="card-body p-0">
                        {loading ? (
                            <div className="text-center p-4">Loading...</div>
                        ) : orders.length === 0 ? (
                            <div className="text-center p-4 text-success">
                                <i className="fas fa-check-circle fa-2x mb-2 d-block"></i>
                                No pending KIPU orders — all caught up!
                            </div>
                        ) : (
                            <table className="table table-hover table-sm mb-0">
                                <thead className="thead-light">
                                    <tr>
                                        <th>Order #</th>
                                        <th>KIPU Sample</th>
                                        <th>Patient</th>
                                        <th>Facility</th>
                                        <th>Collection Date</th>
                                        <th>Created</th>
                                        <th>Age</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {orders.map(order => (
                                        <tr key={order._id}>
                                            <td><strong>{order.lab_order_id}</strong></td>
                                            <td><code>{order.test_info?.sample}</code></td>
                                            <td>
                                                {order.patient_id ?
                                                    `${order.patient_id.last_name}, ${order.patient_id.first_name}` :
                                                    '-'}
                                            </td>
                                            <td>{order.facility_source || '-'}</td>
                                            <td>{order.test_info?.collected ? 
                                                `${order.test_info.collected.toString().substring(4,6)}/${order.test_info.collected.toString().substring(6,8)}/${order.test_info.collected.toString().substring(0,4)}` 
                                                : '-'}</td>
                                            <td>{this.formatDate(order.createdAt)}</td>
                                            <td>
                                                <span className={`badge badge-${
                                                    Math.floor((new Date() - new Date(order.createdAt)) / 1000 / 3600) > 168 ? 'danger' :
                                                    Math.floor((new Date() - new Date(order.createdAt)) / 1000 / 3600) > 72 ? 'warning' : 'secondary'
                                                }`}>
                                                    {this.hoursAgo(order.createdAt)}
                                                </span>
                                            </td>
                                            <td>
                                                <button
                                                    className="btn btn-xs btn-warning"
                                                    onClick={() => this.reprocess(order)}
                                                    disabled={reprocessing[order._id]}
                                                    title="Reset order and request KIPU resend"
                                                >
                                                    {reprocessing[order._id] ?
                                                        <i className="fas fa-spinner fa-spin"></i> :
                                                        <><i className="fas fa-redo mr-1"></i>Reset & Resend</>
                                                    }
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default KipuPendingOrders;
